import { render, staticRenderFns } from "./ScholarshipList.vue?vue&type=template&id=18906e72&scoped=true"
import script from "./ScholarshipList.vue?vue&type=script&lang=js"
export * from "./ScholarshipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18906e72",
  null
  
)

export default component.exports